import Vue from 'vue'
import configs from '../config'

let resource = null

const actions = {
  issueMine: {
    method: 'POST',
    url: `${configs.baseUrl}/api/live-certificates/sessions/{sessionId}/me/issue`,
  },
  getMine: {
    method: 'GET',
    url: `${configs.baseUrl}/api/live-certificates/sessions/{sessionId}/me`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

export const errorCodeOf = (error) => {
  const body = error?.body
  const code = body?.error?.code ?? body?.error ?? body?.code
  return typeof code === 'string' ? code : null
}

const issueMine = async ({ sessionId, audienceId, sessionType }) => {
  const res = await resource.issueMine({ sessionId }, { audienceId, sessionType })
  return res.body
}

const getMine = async ({ sessionId, audienceId, sessionType }) => {
  const res = await resource.getMine({ sessionId, audienceId, sessionType })
  return res.body
}

export default {
  initResource,
  issueMine,
  getMine,
}
